
<div class="container-fluid" [ngStyle]="{'background-image': 'url(../assets/banner4.png)'}">
  <app-main-navbar></app-main-navbar>
  <div class="row main-row">
    <!-- <div class="col-4 logo-container ">
      <div class="logo-text-image-container">
        <img src="assets/QuantIP_Logo.svg" class="logo-img">
        <p class="mellon">Solutions for Innovation Analytics
        </p>
      </div>
      <div class="vr"></div>
    </div> -->

    <div class="col-12 modules-column">

      <div class="card" (click)="openIdeaGeneration()">
        <div class="image-container">
          <img src="/assets/idea_generation_icon.svg" class="card-img-top" alt="..." >
        </div>
        <div class="card-body">
          <h5 class="card-title">Technology Trends</h5>
          <p class="card-text">Find trending themes among the innovation landscape and high-potential investment
            opportunities.</p>
        </div>
      </div>
      
      <div class="card" (click)="openCompanySearch()">
        <div class="image-container">
          <img src="/assets/company_search_icon.svg" class="card-img-top" alt="...">
        </div>
        <div class="card-body">
          <h5 class="card-title">Company Insights</h5>
          <p class="card-text">Evaluate the innovative strength of companies of interest and benchmark them against
            competition.
          </p>
        </div>
      </div>


      <div class="card" (click)="openThematicSearch()">
        <div class="image-container">
          <img src="/assets/thematic_search_icon.svg" class="card-img-top" alt="...">
        </div>
        <div class="card-body">
          <h5 class="card-title">Thematic Search</h5>
          <p class="card-text">Search for technology-based investment themes and find innovation leaders in each area.
          </p>
        </div>
      </div>

      <!-- <div class="card" (click)="openProBot()" *ngIf="roles!.includes('alpha') ">
        <div class="image-container">
          <img src="/assets/idea_generation_icon.svg" class="card-img-top" alt="..." >
        </div>
        <div class="card-body" *ngIf="roles!.includes('alpha') ">
          <h5 class="card-title">"Pro Bot"</h5>
          <p class="card-text">Sample testing
          </p>
        </div>
      </div> -->
      <div class="card" (click)="openMonitoring()">
        <div class="image-container">
          <img src="/assets/monitoring.svg" class="card-img-top" alt="...">
        </div>
        <div class="card-body">
          <h5 class="card-title">Monitoring & Watchlists</h5>
          <p class="card-text">Set up watchlists and monitor companies in your investment universe.</p>
        </div>
      </div>

   

    </div>
  </div>
  <!-- <div class="row  wave-row">
    <div class="col p-0">
      <img src="assets/wave.svg" class="img-fluid wave-img">
    </div>
  </div> -->

</div>
